import zh from "./zh.js";
import en from "./en.js";
import tw from "./tw.js";
import vi from "./vi.js";
import tr from "./tr.js";
import th from "./th.js";
import sv from "./sv.js";
import ru from "./ru.js";
import pt from "./pt.js";
import pl from "./pl.js";
import nl from "./nl.js";
import ko from "./ko.js";
import ja from "./ja.js";
import it from "./it.js";
import es from "./es.js";
import el from "./el.js";
import de from "./de.js";
import ar from "./ar.js";
import fr from "./fr.js";
export default {
    zh,
    en,
    tw,
    vi,
    tr,
    th,
    sv,
    ru,
    pt,
    pl,
    nl,
    ko,
    ja,
    it,
    es,
    el,
    de,
    ar,
    fr
};
